import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default function CustomerList() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>Customers</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Manage your customer contacts and companies.
      </Typography>
      <Button component={Link} to="/app/customers/new" variant="contained">
        Add Customer
      </Button>
    </Box>
  );
}
